import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "66",
  height: "66",
  viewBox: "0 0 66 66",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      d: "M28.416 46V25.6123L25.3906 19.1641H40.5977L37.5684 25.6123V46H28.416ZM31.3906 29.7402V33.123C31.3906 33.5474 31.5593 33.9538 31.8594 34.2539C32.1594 34.554 32.5678 34.7227 32.9922 34.7227C33.4165 34.7227 33.823 34.554 34.123 34.2539C34.4231 33.9538 34.5918 33.5474 34.5918 33.123V29.7402C34.5918 29.3159 34.4231 28.9085 34.123 28.6084C33.823 28.3083 33.4165 28.1396 32.9922 28.1396C32.5678 28.1396 32.1594 28.3083 31.8594 28.6084C31.5593 28.9085 31.3906 29.3159 31.3906 29.7402V29.7402ZM31.8496 30.1621C31.8609 29.9393 31.9384 29.7248 32.0703 29.5449C32.2022 29.365 32.3827 29.2272 32.5918 29.1494C32.8009 29.0716 33.0287 29.0575 33.2461 29.1074C33.4635 29.1573 33.6622 29.2695 33.8164 29.4307C33.9706 29.5919 34.073 29.7943 34.1133 30.0137C34.1535 30.2331 34.1299 30.4596 34.043 30.665C33.956 30.8705 33.8106 31.0461 33.625 31.1699C33.4394 31.2937 33.2211 31.3608 32.998 31.3623C32.6864 31.355 32.3912 31.2244 32.1758 30.999C31.9604 30.7737 31.8429 30.4718 31.8496 30.1602V30.1621ZM40.9922 18.1123H25V16H41V18.1123H40.9922Z",
      fill: $props.color
    }, null, 8, _hoisted_2)
  ]))
}